import { AddToastPayload } from 'modules/Layout/action';
import { ColorVariants } from 'modules/Shared/type';
import { TOAST_CLOSE_IN } from 'modules/Layout/type';

export const copyToClipboardToastSuccess = (): AddToastPayload => ({
  header: 'Clipboard',
  body: 'Copied to clipboard.',
  color: ColorVariants.Success,
  closeIn: TOAST_CLOSE_IN
});

export const copyToClipboardToastError = (): AddToastPayload => ({
  header: 'Clipboard',
  body: 'Failed copy to clipboard.',
  color: ColorVariants.Danger,
  closeIn: TOAST_CLOSE_IN
});
